import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon } from 'lucide-react';
export function AuthorSection() {
  return <section className="py-20 px-4 bg-cream-50" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-10 md:p-14 rounded-3xl shadow-sm border border-cream-200" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-serif text-brown-800 mb-6" data-id="element-4">
            By Mari Algarra
          </h2>
          <p className="text-lg text-stone-600 mb-8 leading-relaxed" data-id="element-5">
            No necesitas ser experta. Necesitas dirección. Este plan está
            diseñado para mujeres reales, con historias reales, que quieren
            construir algo propio con propósito —sin complicarse.
          </p>

          <a href="https://instagram.com/byMariAlgarra" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-terracotta-500 font-medium hover:text-terracotta-600 transition-colors" data-id="element-6">
            <InstagramIcon className="w-5 h-5" data-id="element-7" />
            @byMariAlgarra
          </a>
        </motion.div>
      </div>
    </section>;
}